import { shallowEqual, useSelector } from 'react-redux';
import { getReferralCampaign } from '../../selectors';
import { IReferralCampaign } from '../../interfaces';
import { IStore } from 'store/interface';

export const useReferralCampaign = (id: string) => ({
  campaign: useSelector<IStore, IReferralCampaign | null>(getReferralCampaign(id), shallowEqual),
});
